
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import Book from '@/components/book'
import photo from '@/assets/logo.png'
import css3 from '@/assets/css.jpg'

export default {
  components: {
    Group,
    Cell,
    Swiper,
    SwiperItem,
    Book
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      css3,
      msg: 'Hello World!',
      index:0,
      bg:{
        backgroundColor:'#e0e0e0'
      },
      txt:'JavaScript一种直译式脚本语言，是一种动态类型、弱类型、基于原型的语言，内置支持类型。它的解释器被称为JavaScript引擎，为浏览器的一部分，广泛用于客户端的脚本语言，最早是在HTML（标准通用标记语言下的一个应用）网页上使用，用来给HTML网页增加动态功能。',
      photo,
      text1:'层叠样式表(英文全称：Cascading Style Sheets)是一种用来表现HTML（标准通用标记语言的一个应用）或XML（标准通用标记语言的一个子集）等文件样式的计算机语言。CSS不仅可以静态地修饰网页，还可以配合各种脚本语言动态地对网页各元素进行格式化。'
    }
  },
  mounted(){
    
  },
  watch:{
    index(val){
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/home.vue